import './ErrorMessage.css';

interface ErrorMessageProps {
  message: string;
}

export function ErrorMessage({ message }: ErrorMessageProps) {
  return (
    <div className="ErrorMessage">
      <p>Error: {message}</p>
    </div>
  );
}
